/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IPreCrawlQuery {
  url?: null | string;
}
export class PreCrawlQuery extends BaseModel implements IPreCrawlQuery {
  url?: null | string;
}

